import React from "react";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";

class TypeAheadToggle extends React.Component {
  handleClick = e => {
    e.preventDefault();
    this.props.onClick(e);
  };

  render() {
    const { value, error } = this.props;

    const button = (
      <Button
        style={{
          borderRadius: "4px",
          padding: "12px 15px",
          width: "100%",
          textAlign: "left",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          border: error && "1px solid red"
        }}
        onClick={this.handleClick}
      >
        {this.props.children}
      </Button>
    );

    if (value && value !== "Select ingredient") {
      const tooltip = (
        <Tooltip id={`tooltip-${value.replace(/[^a-zA-Z0-9]/g, "-")}`}>
          {value}
        </Tooltip>
      );
      return (
        <OverlayTrigger placement="top" overlay={tooltip}>
          {button}
        </OverlayTrigger>
      );
    }

    return button;
  }
}

export default TypeAheadToggle;
